<template>
  <button @click="show" :aria-label="$t('buttons.delete')" :title="$t('buttons.delete')" class="action" id="delete-button">
    <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
    <span>{{ $t('buttons.delete') }}</span>
  </button>
</template>

<script>
import { Trash2Icon } from 'vue-feather-icons';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'delete-button',
  computed: {
    ...mapState(['req', 'selected']),
    ...mapGetters(['isSharedDrive']),
  },
  components: {
    Trash2Icon
  },
  methods: {
    show: function () {
      if (this.req[this.selected[0]] || this.req.items[this.selected[0]].type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
        this.$store.commit('showHover', 'delete-shared-drive');
      } else {
        this.$store.commit('showHover', 'delete');
      }
    }
  }
};
</script>
